import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../state/refresh'
import { useRequests } from '../requests/useRequests'

export const useStagesManagement = (projectId: string | undefined) => {
  const requestMaker = useRequests()
  const dispatch = useDispatch()

  const [isAddingStage, setIsAddingStage] = useState(false)
  const [newStageName, setNewStageName] = useState('')
  const [newStageStartDate, setNewStageStartDate] = useState('')
  const [newStageEndDate, setNewStageEndDate] = useState('')
  const [editedStageName, setEditedStageName] = useState('')
  const [editedStageStartDate, setEditedStageStartDate] = useState('')
  const [editedStageEndDate, setEditedStageEndDate] = useState('')
  const [isEditingStage, setIsEditingStage] = useState<string | null>(null)

  const fetchProject = async () => {
    if (!projectId) return null
    const projectData = await requestMaker.getProject(projectId)
    if (projectData) {
      return projectData
    }
    return null
  }

  const handleAddStage = async () => {
    if (!newStageName.trim() || !projectId) return
    const success = await requestMaker.addProjectScheduleStage(projectId, {
      name: newStageName,
      startDate: newStageStartDate || undefined,
      endDate: newStageEndDate || undefined
    })
    if (success) {
      setIsAddingStage(false)
      setNewStageName('')
      setNewStageStartDate('')
      setNewStageEndDate('')
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Etap został dodany'
        })
      )
    }
  }

  const handleUpdateStage = async (stageId: string) => {
    if (!editedStageName.trim() || !projectId) return
    const success = await requestMaker.updateProjectScheduleStage(projectId, stageId, {
      name: editedStageName,
      startDate: editedStageStartDate || undefined,
      endDate: editedStageEndDate || undefined
    })
    if (success) {
      setIsEditingStage(null)
      setEditedStageName('')
      setEditedStageStartDate('')
      setEditedStageEndDate('')
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Etap został zaktualizowany'
        })
      )
    }
  }

  const handleDeleteStage = async (stageId: string) => {
    if (!projectId) return
    const success = await requestMaker.deleteProjectScheduleStage(projectId, stageId)
    if (success) {
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Etap został usunięty'
        })
      )
    }
  }

  const formatDateForInput = (dateString?: string) => {
    if (!dateString) return ''
    try {
      const date = new Date(dateString)
      if (isNaN(date.getTime())) return ''
      return date.toISOString().split('T')[0]
    } catch (error) {
      console.error('Błąd formatowania daty:', error)
      return ''
    }
  }

  const handleStartEditingStage = (stageId: string, name: string, startDate?: string, endDate?: string) => {
    setIsEditingStage(stageId)
    setEditedStageName(name)
    setEditedStageStartDate(formatDateForInput(startDate))
    setEditedStageEndDate(formatDateForInput(endDate))
  }

  return {
    isAddingStage,
    setIsAddingStage,
    newStageName,
    setNewStageName,
    newStageStartDate,
    setNewStageStartDate,
    newStageEndDate,
    setNewStageEndDate,
    editedStageName,
    setEditedStageName,
    editedStageStartDate,
    setEditedStageStartDate,
    editedStageEndDate,
    setEditedStageEndDate,
    isEditingStage,
    setIsEditingStage,
    handleAddStage,
    handleUpdateStage,
    handleDeleteStage,
    handleStartEditingStage,
    fetchProject
  }
}
